import { OneUserLetterboxdData } from '../resources/Letterboxd';
import Loader from './Loader';
import { makeClassName } from '@siteless/util';
import withSuspense from './withSuspense';
import LetterboxdIcon from './LetterboxdIcon';
import { IconAlertTriangle } from './IconAlertTriangle';
import useCopy from '../util/useCopy';

export let LetterboxdAccountDisplay = withSuspense(
  ({ letterboxdId }: { letterboxdId: string }) => {
    let copy = useCopy();
    let result = OneUserLetterboxdData.use(letterboxdId);

    if (!result || result.status === 'error') {
      return (
        <div
          className={makeClassName(
            'flex items-center justify-center gap-2 rounded-xl border-4 p-3 text-neutral-500',
          )}
        >
          <IconAlertTriangle className="h-5 w-5 flex-none" />
          <div className="text-sm">{copy['Letterboxd is unavailable right now']}</div>
        </div>
      );
    }

    return (
      <div
        className={makeClassName(
          'flex items-center justify-center gap-2 rounded-xl border-4 p-3',
        )}
      >
        <LetterboxdIcon className="h-8 w-8" />
        <div className="font-medium">{result.data.username}</div>
      </div>
    );
  },
  {
    fallback: (
      <div className="h-14">
        <Loader />
      </div>
    ),
  },
);
